import { embedOrigin, initialFrameUrl, linkFrameUrl } from './utils/embedFrameUrl';

(function() {
    const opts = window._hcEmbedOpts || {};
    // `typeof` because a snippet that sets only `_hcEmbedOpts` never declares
    // the bare `subdomain` global, and reading it would throw.
    const helpCenterDomain = embedOrigin(opts, typeof subdomain !== 'undefined' ? subdomain : undefined);
    if (!helpCenterDomain) {
        console.error('HelpCenter.io embed: set _hcEmbedOpts.subdomain or _hcEmbedOpts.customDomain.');
        return;
    }
    // Create the iframe
    var iframe = document.createElement('iframe');
    iframe.allow = 'clipboard-read; clipboard-write';

    // Listen to message from child IFrame window. Registered once: from
    // iframe.onload it gained another copy on every navigation in the frame.
    window.addEventListener('message', function (e) {
        if (e.origin !== helpCenterDomain) {
            return;
        }

        if (e.data.type && e.data.type === 'SET_IFRAME_HEIGHT') {
            // Set the height of the iframe based on the received message
            iframe.style.height = e.data.height + 'px';
        }

        if (e.data.type && e.data.type === 'IFRAME_URL_CHANGE') {
            // Set the parent page's URL hash to the path from the iframe
            window.location.hash = e.data.path;
        }

        if (e.data.type && e.data.type === 'INTERNAL_LINK_CLICKED') {
            const url = linkFrameUrl(helpCenterDomain, e.data.url);
            if (!url) {
                return;
            }
            window.location.hash = url.slice(helpCenterDomain.length);
            iframe.height = '100%';
            iframe.style.height = "100vh";
            iframe.src = url;
        }
    }, false);

    // Set attributes for the iframe
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.frameBorder = '0';
    iframe.style = "height:100vh;overflow-y:none;frameborder:0;"

    iframe.src = initialFrameUrl(helpCenterDomain, window.location.hash);

    var embedElement = document.getElementById('hc_embed');
    if (embedElement) {
        embedElement.appendChild(iframe);
    }
})();
